import { render, staticRenderFns } from "./VideoConference.vue?vue&type=template&id=748f2c4a&"
import script from "./VideoConference.vue?vue&type=script&lang=js&"
export * from "./VideoConference.vue?vue&type=script&lang=js&"
import style0 from "./VideoConference.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
